import { useEffect } from 'react';
import { useDidMount } from './useDidMount';
import { useLocation } from 'react-router-dom';
import { chromeExtensionHelpers } from '../helpers/chromeExtensionHelpers';
import { isFromChromeExtension } from '../providers/AppProvider';

export const useChromeExtension = () => {
  const location = useLocation();

  // Notify when the app is loaded.
  useDidMount(() => {
    if (isFromChromeExtension) {
      chromeExtensionHelpers.sendAppLoadedMessage();
    }
  });

  // Notify when the app navigates away from post-editor, as it shouldn't do this.
  useEffect(() => {
    // Don't check 'isFromChromeExtension' as there can be edge cases where we clear session storage and this won't
    // be true anymore.
    if (!location.pathname.includes('post-editor')) {
      chromeExtensionHelpers.sendNavigatedAwayMessage();
    }
  }, [location]);
};
